<template>
    <div :class="['join-us', sub_class]">
        <div class="container">
            <div class="content">
                <div class="aligncenter" v-html="text"></div>

                <div class="aligncenter">
                    <a
                        class="btn default"
                        id="show-modal"
                        v-if="video_url"
                        @click="showModal = true"
                    >
                        <svg
                            width="13px"
                            height="14px"
                            viewBox="0 0 13 14"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <g
                                id="latest-deck"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                            >
                                <g
                                    id="3-offer"
                                    class="btn-svg"
                                    transform="translate(-827.000000, -1427.000000)"
                                    fill="#FFFFFF"
                                >
                                    <polygon
                                        id="Path-2"
                                        points="827 1427 827 1441.03125 839.1875 1434.03125"
                                    />
                                </g>
                            </g>
                        </svg>
                        {{button_video_text}}
                    </a>
                </div>
            </div>
            <modal v-if="showModal" @close="showModal = false">
                <div slot="content">
                    <div class="videoWrapper">
                        <iframe
                            :src="video_url"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
    props: ["blockdata"],
    name: "block-join-us",
    data() {
        return {
            text: this.blockdata.text,
            video_url: this.blockdata.video_url,
			button_video_text: this.blockdata.button_video_text,
			sub_class: this.blockdata.class,
            showModal: false
        };
    },
    components: {
        Modal
    },
    mounted: function() {}
};
</script>



// WEBPACK FOOTER //
// BlockJoinUs.vue?dd438ada